/* eslint-disable react/jsx-props-no-spreading */

import { useMediaList } from '@api/hooks';
import { useSearchParam as defaultUseSearchParam } from '@hooks';
import { FILTER_OPTIONS } from '@api/media/constants';
import { TAG_TYPE } from '@api/mediaTags/constants';
import { useRecordTable } from '@templates/RecordTable';

const relatedTagIdRegexp = new RegExp(`^(${Object.values(TAG_TYPE).join('|')}):[a-zA-Z0-9]+$`);
const relatedTagValidator = (value) => relatedTagIdRegexp.test(value);

export const useMediaLibrary = ({
  validateTagParams = relatedTagValidator,
  listQueryVariables,
  useSearchParam = defaultUseSearchParam,
  ...config
} = {}) => {
  const [tag, setTag] = useSearchParam({ key: 'tag', validate: validateTagParams });

  const recordTable = useRecordTable({
    useList: useMediaList,
    listQueryVariables: { tag, ...listQueryVariables },
    useDelete: () => [],
    useDeleteMany: () => [],
    getDataSource: ({ medias }) => medias.data,
    validateFilterParams: (value) => FILTER_OPTIONS.some(({ key }) => key === value),
    transformFilter: (filter) => ({ type: filter }),
    rowKey: 'id',
    perPage: 36,
    useSearchParam,
    ...config,
  });

  return {
    tag: { value: tag, set: setTag },
    ...recordTable,
  };
};
